import { render, staticRenderFns } from "./DeptAssetList.vue?vue&type=template&id=48e1bd40"
import script from "./DeptAssetList.vue?vue&type=script&lang=js"
export * from "./DeptAssetList.vue?vue&type=script&lang=js"
import style0 from "./DeptAssetList.vue?vue&type=style&index=0&id=48e1bd40&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports